import './App.css';
import AppRoutes from './routes/AppRoutes';
import 'flowbite';
function App() {
  return (
    <div className="App">
      <AppRoutes/>
    </div>
  );
}

export default App;
